




import { createFeatureSelector, ActionReducerMap } from '@ngrx/store';
import { IEntityState, buildFeatureState } from '@briebug/ngrx-auto-entity';
import { StatutNotification } from './statut-notification.model';

export interface IStatutNotificationState {
    statutNotification: IEntityState<StatutNotification>;
}

export const STATUTNOTIFICATION = 'statutNotification';

export const statutNotificationState = createFeatureSelector<IStatutNotificationState>(
    STATUTNOTIFICATION
);

export const { initialState: initialStatutNotificationState, selectors, facade: statutNotificationFacadeBase } = buildFeatureState(
    StatutNotification,
    STATUTNOTIFICATION,
    statutNotificationState
);

export function statutNotificationReducer(state = initialStatutNotificationState): IEntityState<StatutNotification> {
    return state;
}

export const statutNotificationReducers: ActionReducerMap<IStatutNotificationState> = {
    statutNotification: statutNotificationReducer
};